import React from "react";
import Reveal from "../site/Reveal";
import { SectionLabel, Chip, PrimaryButton } from "../site/Bits";
import { SOCIAL_IMPACT, FOCUS_AREAS } from "../../lib/content";
import { IMAGES } from "../../lib/images";

export default function SocialImpactBand() {
  return (
    <section className="cinematic relative isolate overflow-hidden" data-testid="social-impact-section">
      <div className="absolute inset-0 z-0" aria-hidden="true">
        <img
          src={IMAGES.socialImpact.band}
          alt=""
          className="h-full w-full object-cover"
          style={{ opacity: 0.3, objectPosition: "center 30%" }}
          loading="lazy"
        />
      </div>
      <div
        className="grain absolute inset-0 z-10"
        aria-hidden="true"
        style={{
          background:
            "linear-gradient(100deg, rgba(14,13,20,0.96) 12%, rgba(14,13,20,0.84) 52%, rgba(14,13,20,0.58) 100%)",
        }}
      />

      <div className="lk-container-wide relative z-20 py-[clamp(40px,4.2vw,70px)]">
        <div className="grid gap-y-12 lg:grid-cols-12 lg:gap-x-14">
          <div className="lg:col-span-6">
            <Reveal>
              <SectionLabel onDark>Social Impact</SectionLabel>
            </Reveal>
            <Reveal delay={0.08}>
              <h2 className="display-lg mt-7 max-w-[18ch]" style={{ color: "#FBFAF7" }}>
                {SOCIAL_IMPACT.heading}
              </h2>
            </Reveal>
            <Reveal delay={0.14}>
              <p
                className="mt-7 max-w-[46ch] text-[15px] leading-[1.7]"
                style={{ color: "rgba(247,246,242,0.78)" }}
              >
                {SOCIAL_IMPACT.body}
              </p>
              <p className="mt-7 font-display text-[15px] italic" style={{ color: "rgba(216,183,122,0.92)" }}>
                {SOCIAL_IMPACT.tagline}
              </p>
            </Reveal>
            <Reveal delay={0.2}>
              <div className="mt-11">
                <PrimaryButton
                  to="/social-impact"
                  variant="ivory"
                  data-testid="social-impact-support-a-cause-cta"
                >
                  {SOCIAL_IMPACT.homeCta}
                </PrimaryButton>
              </div>
            </Reveal>
          </div>

          <div className="lg:col-span-5 lg:col-start-8 lg:self-center">
            <Reveal delay={0.16}>
              <span
                className="eyebrow eyebrow-on-dark block"
                style={{ color: "rgba(247,246,242,0.5)" }}
              >
                Focus Areas
              </span>
              <div className="mt-6 flex flex-wrap gap-[10px]">
                {FOCUS_AREAS.map((area) => (
                  <Chip key={area.title} onDark>
                    {area.title}
                  </Chip>
                ))}
              </div>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
}
